<div class="card header-card">
  <h1>CookAdHoc<sup>®</sup>:&nbsp;&nbsp;Interfaz de gestión</h1>
</div>
<div class="row">
  <div class="column col-md-4 col-sm-4 col-xs-12">
    <div class="card" routerLink="/platos">
      <div class="card-header">Gestionar platos</div>
      <div class="card-body">
        <i class="fa fa-cutlery fa-1"></i>&nbsp;&nbsp;Tiene permisos para editar
        los platos existentes.
      </div>
    </div>
  </div>
  <div class="column col-md-4 col-sm-4 col-xs-12">
    <div class="card" routerLink="/platos/editar">
      <div class="card-header">Añadir un nuevo plato</div>
      <div class="card-body">
        <i class="fa fa-plus-square fa-2"></i>&nbsp;&nbsp;Tiene permisos para
        añadir nuevos platos al sistema.
      </div>
    </div>
  </div>
  <div class="column col-md-4 col-sm-4 col-xs-12">
    <div class="card" routerLink="/ingredientes-condimentos">
      <div class="card-header">Ingredientes y condimentos</div>
      <div class="card-body">
        <i class="fa fa-plus-square fa-2"></i>&nbsp;&nbsp;Consulte y descargue
        el listado de ingredientes y condimentos actualizado.
      </div>
    </div>
  </div>
  <div class="column col-md-4 col-sm-4 col-xs-12">
    <div class="card" routerLink="/neveras">
      <div class="card-header">Gestionar neveras</div>
      <div class="card-body">
        <i class="fa fa-cutlery fa-1"></i>&nbsp;&nbsp;Tiene permisos para editar
        las neveras existentes.
      </div>
    </div>
  </div>
  <div class="column col-md-4 col-sm-4 col-xs-12">
    <div class="card" routerLink="/neveras/editar">
      <div class="card-header">Añadir un nueva nevera</div>
      <div class="card-body">
        <i class="fa fa-plus-square fa-2"></i>&nbsp;&nbsp;Tiene permisos para
        añadir nuevas neveras al sistema.
      </div>
    </div>
  </div>
  <div class="column col-md-4 col-sm-4 col-xs-12" *ngIf="userRole == 'admin'">
    <div class="card" routerLink="/usuarios">
      <div class="card-header">Gestionar usuarios/as</div>
      <div class="card-body">
        <i class="fa fa-users fa-3"></i>&nbsp;&nbsp;Tiene permisos para editar
        los usuarios/as y gestionar sus roles.
      </div>
    </div>
  </div>
  <div class="column col-md-4 col-sm-4 col-xs-12">
    <form ngNoForm [action]="noUbicadosURL" method="get">
      <button class="card" type="submit">
        <div class="card-header">Platos sin ubicación</div>
        <div class="card-body">
          <i class="fa fa-file-excel-o"></i>&nbsp;&nbsp;Puede descargar un
          fichero CSV con los platos que no tienen cumplimentada la localidad y
          el país.
        </div>
      </button>
    </form>
  </div>
  <div class="column col-md-4 col-sm-4 col-xs-12">
    <form ngNoForm [action]="frasesURL" method="get">
      <button class="card" type="submit">
        <div class="card-header">Frases y citas de Alicia</div>
        <div class="card-body">
          <i class="fa fa-file-excel-o"></i>&nbsp;&nbsp;Puede descargar un
          fichero CSV con las frases incluidas en la aplicación. Para incluir o
          corregir frases, contacte con el administrador.
        </div>
      </button>
    </form>
  </div>
</div>
<div class="card mt-2" *ngIf="estadisticas">
  <div class="card-body">
    <div class="row text-center">
      <div class="column col-md-4 col-sm-4 col-xs-12">
        <h2>{{ estadisticas.num_platos }}</h2>
        Platos almacenados
      </div>
      <div class="column col-md-4 col-sm-4 col-xs-12">
        <h2>{{ estadisticas.num_ingredientes }}</h2>
        Ingredientes asignados
      </div>
      <div class="column col-md-4 col-sm-4 col-xs-12">
        <h2>{{ estadisticas.num_condimentos }}</h2>
        Condimentos asignados
      </div>
      <div class="column col-md-4 col-sm-4 col-xs-12">
        <hr />
        <br />
        <h2>{{ meses[estadisticas.mes_favorito - 1] }}</h2>
        Es el mes con más platos
      </div>
      <div class="column col-md-4 col-sm-4 col-xs-12">
        <hr />
        <br />
        <h2>{{ estadisticas.ingrediente_favorito }}</h2>
        Es el ingrediente más utilizado
      </div>
      <div class="column col-md-4 col-sm-4 col-xs-12">
        <hr />
        <br />
        <h2>{{ estadisticas.condimento_favorito }}</h2>
        Es el condimento más utilizado
      </div>
      <div class="column col-md-4 col-sm-4 col-xs-12">
        <hr />
        <br />
        <h2>{{ estadisticas.num_neveras_despensas }}</h2>
        Neveras / despensas almacenadas
      </div>
      <!--<div class="column col-md-4 col-sm-4 col-xs-12">
        <hr />
        <br />
        <h2>{{ estadisticas.num_vestidos }}</h2>
        Vestidos almacenados
      </div>-->
      <div class="column col-md-4 col-sm-4 col-xs-12">
        <hr />
        <br />
        <h2>{{ estadisticas.num_users }}</h2>
        Usuarios/as registrados
      </div>
      <div class="column col-md-4 col-sm-4 col-xs-12">
        <hr />
        <br />
        <h2>
          {{ estadisticas.no_ubicacion }}
        </h2>
        Platos sin ubicación ({{
          (estadisticas.no_ubicacion * 100) / estadisticas.num_platos
            | number : "1.2"
        }}
        %)
        <br /><br />
        <button (click)="getNoUbicados()" class="btn btn-sm btn-success">
          Descargar detalle en CSV (1)&nbsp;&nbsp;<i
            class="fa fa-file-excel-o"
            style="color: white"
            aria-hidden="true"
          ></i>
        </button>
      </div>
    </div>
  </div>
</div>
